"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LB = void 0;
exports.LB = {
    numericCode: '422',
    alpha2Code: 'LB',
    alpha3Code: 'LBN',
    englishName: {
        short: 'Lebanon',
        full: 'the Lebanese Republic',
    },
    names: {
        full: {
            en: 'the Lebanese Republic',
            fr: 'la République libanaise',
            ar: 'Lubnān',
        },
        short: {
            en: 'Lebanon',
            fr: 'Liban (le)',
            ar: 'Lubnān',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'ar',
            languageAlpha3Code: 'ara',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
    ],
    subdivisions: {
        'LB-AK': {
            numericCode: '422',
            code: 'LB-AK',
            category: {
                id: '208',
                names: {
                    ar: {
                        singular: 'mouhâfazah, muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Aakkâr',
            },
        },
        'LB-AS': {
            numericCode: '422',
            code: 'LB-AS',
            category: {
                id: '208',
                names: {
                    ar: {
                        singular: 'mouhâfazah, muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Liban-Nord',
            },
        },
        'LB-BA': {
            numericCode: '422',
            code: 'LB-BA',
            category: {
                id: '208',
                names: {
                    ar: {
                        singular: 'mouhâfazah, muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Beyrouth',
            },
        },
        'LB-BH': {
            numericCode: '422',
            code: 'LB-BH',
            category: {
                id: '208',
                names: {
                    ar: {
                        singular: 'mouhâfazah, muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Baalbek-Hermel',
            },
        },
        'LB-BI': {
            numericCode: '422',
            code: 'LB-BI',
            category: {
                id: '208',
                names: {
                    ar: {
                        singular: 'mouhâfazah, muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Al Biqā‘',
            },
        },
        'LB-JA': {
            numericCode: '422',
            code: 'LB-JA',
            category: {
                id: '208',
                names: {
                    ar: {
                        singular: 'mouhâfazah, muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Liban-Sud',
            },
        },
        'LB-JL': {
            numericCode: '422',
            code: 'LB-JL',
            category: {
                id: '208',
                names: {
                    ar: {
                        singular: 'mouhâfazah, muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Jabal Lubnān',
            },
        },
        'LB-NA': {
            numericCode: '422',
            code: 'LB-NA',
            category: {
                id: '208',
                names: {
                    ar: {
                        singular: 'mouhâfazah, muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'An Nabaţīyah',
            },
        },
    },
    cities: [
        {
            name: 'Zahlé',
            subdivision: 'Béqaa',
        },
        {
            name: 'Tripoli',
            subdivision: 'Liban-Nord',
        },
        {
            name: 'Tyre',
            subdivision: 'Liban-Sud',
        },
        {
            name: 'Sidon',
            subdivision: 'Liban-Sud',
        },
        {
            name: 'Ra’s Bayrūt',
            subdivision: 'Beyrouth',
        },
        {
            name: 'Djounie',
            subdivision: 'Mont-Liban',
        },
        {
            name: 'Jbaïl',
            subdivision: 'Mont-Liban',
        },
        {
            name: 'Habboûch',
            subdivision: 'Nabatîyé',
        },
        {
            name: 'Bcharré',
            subdivision: 'Liban-Nord',
        },
        {
            name: 'Beirut',
            subdivision: 'Beyrouth',
        },
        {
            name: 'Baalbek',
            subdivision: 'Baalbek-Hermel',
        },
        {
            name: 'En Nâqoûra',
            subdivision: 'Liban-Sud',
        },
        {
            name: 'Nabatîyé et Tahta',
            subdivision: 'Nabatîyé',
        },
    ],
};
//# sourceMappingURL=data:application/json;base64,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